module.exports = __webpack_public_path__ + "media/packs/images/flags/CA-a0979f79bb36ebfa8338eb3a2b7732ce.png";